<template>
  <modal
    class="notified-participants-modal"
    name="notified-participants-modal"
    @before-open="handleBeforeOpen"
    @before-close="handleBeforeClose"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="60%"
    height="80%"
    style="z-index: 4100;"
  >
    <div id="modal-header" class="action-modal">
      <div class="w-75 d-flex">
        <p>Ծանուցված մասնակիցներ {{ procurementTitle ? `- ${procurementTitle}` : '' }}</p>
      </div>
      <button
        type="button"
        class="close position-absolute"
        style="right: 1.25rem; top: 25%"
        @click="$modal.hide('notified-participants-modal')"
        aria-label="Close"
      >
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
        </svg>
      </button>
    </div>
    <div id="modal-body" class="p-4">
      <div v-if="loading" class="text-center py-4">
        <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
        <span class="ml-2">Բեռնում...</span>
      </div>
      <template v-else>
        <div class="mb-4">
          <p class="tender-label mb-2 font-weight-bold">Ծանուցված կազմակերպություններ</p>
          <v-client-table :columns="columns" v-model="organisations" :options="options">
            <div slot="index_number" class="d-flex justify-content-start align-items-center h-100" slot-scope="{index}">
              <span>{{ index }}</span>
            </div>
            <div slot="name" class="d-flex justify-content-start align-items-center h-100" slot-scope="{row}">
              <span>{{ row.name }}</span>
            </div>
          </v-client-table>
        </div>

        <div class="mt-3">
          <p class="tender-label mb-2 font-weight-bold">Ծանուցվող էլ․ հասցեներ</p>
          <ul v-if="emails.length" class="list-group">
            <li
              v-for="(email, idx) in emails"
              :key="idx"
              class="list-group-item d-flex align-items-center py-2 px-3"
            >
              <span class="text-muted mr-3">{{ idx + 1 }}.</span>
              <span>{{ email }}</span>
            </li>
          </ul>
          <p v-else class="text-muted mb-0">Ծանուցվող էլ․ հասցեներ չկան</p>
        </div>
      </template>
    </div>
    <div id="modal-footer" class="p-3 text-right">
      <button type="button" @click="$modal.hide('notified-participants-modal')" class="btn btn-secondary br-8">
        <span>Փակել</span>
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NotifiedParticipantsModal',
  data() {
    return {
      loading: false,
      procurementTitle: '',
      organisations: [],
      emails: [],
      columns: [
        'index_number',
        'name',
      ],
      options: {
        sortable: [],
        perPage: 1000,
        perPageValues: [],
        columnsDropdown: false,
        filterByColumn: false,
        skin: 'table table-striped table-border-radius',
        headings: {
          index_number: 'Հ/Հ',
          name: 'Անվանումը',
        },
        texts: {
          noResults: 'Ծանուցված կազմակերպություններ չկան',
        },
        filterable: false,
      },
    };
  },
  methods: {
    handleBeforeOpen({ params }) {
      const organizeId = params?.organizeId || params?.procurement?.id;
      const procurement = params?.procurement;
      this.procurementTitle = procurement
        ? [procurement.name, procurement.code].filter(Boolean).join(' - ')
        : '';
      if (organizeId) {
        this.fetchNotifiedParticipants(organizeId);
      }
    },
    handleBeforeClose() {
      this.loading = false;
      this.procurementTitle = '';
      this.organisations = [];
      this.emails = [];
    },
    async fetchNotifiedParticipants(organizeId) {
      this.loading = true;
      try {
        const { data } = await this.$client.get(`organize/itender/notified-participants/${organizeId}`);
        const payload = data?.data || data || {};
        this.organisations = Array.isArray(payload.organisations) ? payload.organisations : [];
        this.emails = Array.isArray(payload.emails) ? payload.emails : [];
      } catch (e) {
        console.error('Failed to fetch notified participants', e);
        this.organisations = [];
        this.emails = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.br-8 {
  border-radius: 8px;
}
</style>
